var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRowVertical(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/row-vertical"
  }, /*#__PURE__*/React.createElement("g", {
    id: "row-vertical"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.7543 10.6875H3.246C2.0585 10.6875 1.5835 11.1942 1.5835 12.4529V15.6513C1.5835 16.91 2.0585 17.4167 3.246 17.4167H15.7543C16.9418 17.4167 17.4168 16.91 17.4168 15.6513V12.4529C17.4168 11.1942 16.9418 10.6875 15.7543 10.6875Z",
    stroke: "#64646F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.7543 1.58334H3.246C2.0585 1.58334 1.5835 2.09001 1.5835 3.34876V6.54709C1.5835 7.80584 2.0585 8.31251 3.246 8.31251H15.7543C16.9418 8.31251 17.4168 7.80584 17.4168 6.54709V3.34876C17.4168 2.09001 16.9418 1.58334 15.7543 1.58334Z",
    stroke: "#64646F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRowVertical);
export default __webpack_public_path__ + "static/media/row-vertical.8dd7df8134f445803efa004329fc750d.svg";
export { ForwardRef as ReactComponent };